import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=e2cbfde0&scoped=true&"
import script from "./AssessmentForm.vue?vue&type=script&lang=ts&"
export * from "./AssessmentForm.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentForm.vue?vue&type=style&index=0&id=e2cbfde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cbfde0",
  null
  
)

export default component.exports